import { logError } from '@/utils/loggerUtils';
import * as types from './mutations-types';

export const mutations = {
  [types.RESET_SNIPPET](state) {
    state.editSnippet = false;
    state.snippet.description = null;
  },

  [types.SAVE_SNIPPET_STARTED](state, { hitIdx }) {
    state.snippetExistsArray.splice(hitIdx, 1, true);
    state.isSavingSnippetLoading = true;
  },

  [types.SAVE_SNIPPET_SUCCESS](state, payload) {
    const snippet = payload.snippet;
    const hitIdx = payload.hitIdx;
    snippet.hit_content = payload.hitContent;
    state.snippets.push(snippet);
    state.activeSnippetHashes.push(snippet.hitHashCode);
    // you can't simply set the value at array index because Vue won't be able
    // to detect the change in the array
    state.snippetExistsArray.splice(hitIdx, 1, true);
    state.isSavingSnippetLoading = false;
  },

  [types.SAVE_SNIPPET_FAILURE](state, { hitIdx }) {
    state.snippetExistsArray.splice(hitIdx, 1, false);
    state.isSavingSnippetLoading = false;
  },

  [types.DESTROY_SNIPPET_STARTED](state, { hitIdx }) {
    state.snippetExistsArray.splice(hitIdx, 1, false);
    state.isDestroyingSnippetLoading = true;
  },

  [types.DESTROY_SNIPPET_SUCCESS](state, payload) {
    if (payload.snippet) {
      try {
        const index = state.snippets.findIndex(
          (snip) => snip.id === payload.snippet.id
        );
        state.snippets.splice(index, 1);
      } catch (e) {
        logError(e);
      }
      try {
        const index2 = state.activeSnippetHashes.findIndex(
          (hash) => hash === payload.snippet.hitHashCode
        );
        state.activeSnippetHashes.splice(index2, 1);
      } catch (e) {
        logError(e);
      }
    }
    state.snippet = {
      description: '',
    };
    if (payload.hitIdx) {
      state.snippetExistsArray.splice(payload.hitIdx, 1, false);
    }
    state.isDestroyingSnippetLoading = false;
  },

  [types.DESTROY_SNIPPET_FAILURE](state, { hitIdx }) {
    state.snippetExistsArray.splice(hitIdx, 1, true);
    state.isDestroyingSnippetLoading = false;
  },

  [types.UPDATE_SNIPPET_SUCCESS](state, snippet) {
    state.snippets.map((snip) => {
      if (snip.id === snippet.id) {
        snip.description = snippet.description;
      }
    });
    state.editSnippet = false;
  },

  [types.SHOW_MODAL_SNIPPET](state, payload) {
    state.hit = payload.hit;
    state.hitIdx = payload.hitIdx;
    state.pageNum = payload.pageNum;
    if (payload.edit) {
      const snippet = state.snippets.find(
        (snip) =>
          JSON.parse(snip.hit_content).fields.doc_id[0] ===
            payload.hit.fields.doc_id[0] &&
          snip.query === payload.query &&
          snip.mode === payload.mode
      );
      state.snippet = snippet;
      if (snippet !== null) state.editSnippet = true;
      else state.editSnippet = false;
    } else {
      state.snippet = {
        description: '',
      };
    }
    state.filters = payload.filters;
    state.query = payload.query;
    state.mode = payload.mode;
    state.actionDateStart = payload.actionDateStart;
    state.actionDateEnd = payload.actionDateEnd;
    state.modalSnippet = payload.status;
  },

  [types.SHOW_MODAL_CONFIRM_SNIPPET](state, payload) {
    state.modalConfirm = payload.status;
    if (payload.id) {
      state.snippet = state.snippets.find((snip) => snip.id === payload.id);
    }
  },

  [types.FETCH_SNIPPETS_SUCCESS](state, snippets) {
    if (snippets !== undefined && snippets.length > 0)
      state.snippets = snippets;
    else state.snippets = [];
    state.activeSnippetHashes = state.snippets.map(
      (snippet) => snippet.hitHashCode
    );
  },

  [types.CLEAR_SNIPPETS](state) {
    state.snippets = [];
  },
};
